module.exports = __webpack_public_path__ + "img/coin-shadow.29e1f2b5.png";